import { GenIcon } from '../helpers/IconBase.es.js';
import 'tslib';
import 'react';
import '@teko/styled';
import '../helpers/IconContext.es.js';

const GiftColored = (props) => {
    return GenIcon({
        tag: 'svg',
        attr: { viewBox: '0 0 26 26', fill: 'none' },
        child: [
            {
                tag: 'g',
                attr: { filter: 'url(#filter0_d)' },
                child: [
                    {
                        tag: 'path',
                        attr: {
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                            d: 'M11.6364 6.9847L8.7767 5.151C8.25219 4.81467 7.55366 5.06457 7.35706 5.65888L6.79962 7.34394C6.57498 8.02303 7.1381 8.70292 7.84136 8.60169L11.0885 8.13427C11.0798 8.20942 11.0754 8.28587 11.0754 8.36336C11.0754 9.44791 11.9479 10.3271 13.0242 10.3271C14.1006 10.3271 14.9731 9.44791 14.9731 8.36336C14.9731 8.2883 14.9689 8.21422 14.9608 8.14135L18.1588 8.60169C18.862 8.70292 19.4252 8.02303 19.2005 7.34394L18.6431 5.65888C18.4465 5.06457 17.7479 4.81467 17.2234 5.151L14.3933 6.96575C14.0413 6.6157 13.5578 6.39962 13.0242 6.39962C12.4811 6.39962 11.9898 6.62351 11.6364 6.9847Z',
                            fill: 'url(#paint0_linear)',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M6.04004 11.2901C6.04004 10.7583 6.46789 10.3271 6.99567 10.3271H19.0044C19.5322 10.3271 19.96 10.7583 19.96 11.2901V19.8687C19.96 20.4005 19.5322 20.8316 19.0044 20.8316H6.99567C6.46789 20.8316 6.04004 20.4005 6.04004 19.8687V11.2901Z',
                            fill: 'url(#paint1_linear)',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M5 8.73245C5 8.20065 5.42785 7.76953 5.95563 7.76953H20.0444C20.5722 7.76953 21 8.20065 21 8.73245V11.3294C21 11.8613 20.5722 12.2924 20.0444 12.2924H5.95563C5.42785 12.2924 5 11.8613 5 11.3294V8.73245Z',
                            fill: 'url(#paint2_radial)',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M10.71 7.76953H15.2899V12.2924H10.71V7.76953Z',
                            fill: '#FED546',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M11.0269 12.2925H14.9729V20.8316H11.0269V12.2925Z',
                            fill: 'url(#paint3_linear)',
                        },
                    },
                ],
            },
            {
                tag: 'defs',
                attr: {},
                child: [
                    {
                        tag: 'filter',
                        attr: {
                            id: 'filter0_d',
                            x: '0',
                            y: '0',
                            width: '26',
                            height: '25.8316',
                            filterUnits: 'userSpaceOnUse',
                            colorInterpolationFilters: 'sRGB',
                        },
                        child: [
                            {
                                tag: 'feFlood',
                                attr: { floodOpacity: '0', result: 'BackgroundImageFix' },
                            },
                            {
                                tag: 'feColorMatrix',
                                attr: {
                                    in: 'SourceAlpha',
                                    type: 'matrix',
                                    values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
                                },
                            },
                            { tag: 'feOffset', attr: {} },
                            { tag: 'feGaussianBlur', attr: { stdDeviation: '2.5' } },
                            {
                                tag: 'feColorMatrix',
                                attr: {
                                    type: 'matrix',
                                    values: '0 0 0 0 1 0 0 0 0 0.528167 0 0 0 0 0.379167 0 0 0 0.29 0',
                                },
                            },
                            {
                                tag: 'feBlend',
                                attr: {
                                    mode: 'normal',
                                    in2: 'BackgroundImageFix',
                                    result: 'effect1_dropShadow',
                                },
                            },
                            {
                                tag: 'feBlend',
                                attr: {
                                    mode: 'normal',
                                    in: 'SourceGraphic',
                                    in2: 'effect1_dropShadow',
                                    result: 'shape',
                                },
                            },
                        ],
                    },
                    {
                        tag: 'linearGradient',
                        attr: {
                            id: 'paint0_linear',
                            x1: '13.0001',
                            y1: '5',
                            x2: '13.0001',
                            y2: '8.30689',
                            gradientUnits: 'userSpaceOnUse',
                        },
                        child: [
                            { tag: 'stop', attr: { stopColor: '#FFB81E' } },
                            { tag: 'stop', attr: { offset: '1', stopColor: '#FED546' } },
                        ],
                    },
                    {
                        tag: 'linearGradient',
                        attr: {
                            id: 'paint1_linear',
                            x1: '13',
                            y1: '10.3271',
                            x2: '13',
                            y2: '20.8316',
                            gradientUnits: 'userSpaceOnUse',
                        },
                        child: [
                            { tag: 'stop', attr: { stopColor: '#FF2B2B' } },
                            { tag: 'stop', attr: { offset: '1', stopColor: '#FF2E6C' } },
                        ],
                    },
                    {
                        tag: 'radialGradient',
                        attr: {
                            id: 'paint2_radial',
                            cx: '0',
                            cy: '0',
                            r: '1',
                            gradientUnits: 'userSpaceOnUse',
                            gradientTransform: 'translate(7.61979 9.61593) rotate(61.073) scale(9.30482 8.68326)',
                        },
                        child: [
                            { tag: 'stop', attr: { stopColor: '#FF5B6F' } },
                            {
                                tag: 'stop',
                                attr: { offset: '0.46875', stopColor: '#FF444F' },
                            },
                        ],
                    },
                    {
                        tag: 'linearGradient',
                        attr: {
                            id: 'paint3_linear',
                            x1: '12.9999',
                            y1: '12.2925',
                            x2: '12.9999',
                            y2: '20.8316',
                            gradientUnits: 'userSpaceOnUse',
                        },
                        child: [
                            {
                                tag: 'stop',
                                attr: { stopColor: '#FFB81E', stopOpacity: '0.66' },
                            },
                            {
                                tag: 'stop',
                                attr: { offset: '0.608277', stopColor: '#FFB81E' },
                            },
                        ],
                    },
                ],
            },
        ],
    })(props);
};

export { GiftColored };
